// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesPrivacy = (i) => `Alles wird sicher auf deutschen Servern gespeichert und niemals weitergegeben.`